import { create } from "zustand";
import type { FaqStore } from "./types";
import { fetchFaq, deleteFaq } from "../../../api";
import { asyncActionWrapper } from "../utils/asyncActionWrapper";


export const useFaqsStore = create<FaqStore>((set, get) => ({
    loading: false,
    faqs: [],
    asyncActionWrapper,
    fetchFAQs: async () => {
        set({ loading: true });
        set({ faqs: await fetchFaq() });
        set({ loading: false });
    },
    addFaqWrapper: async (_parsed: any[]) => {
        await get().asyncActionWrapper(
            async () => {
                // await Promise.all(parsed.map((faq: any) => addFaq(faq.question, faq.answer, faq.metadata || [])));
            },
            "FAQs added successfully",
            "Error adding FAQs"
        );
        get().fetchFAQs();
    },
    changeFaqWrapper: async (id: string, question: string, _answer: string, _metadata: any) => {
        await get().asyncActionWrapper(
            async () => {
                // await changeFaq(id, question, answer, metadata);
            },
            `FAQ ${question} updated successfully`,
            `Error updating FAQ ${question}`
        );
        get().fetchFAQs();
    },
    deleteFaqWrapper: async (ids: string[]) => {
        await get().asyncActionWrapper(
            async () => {
                await Promise.all(ids.map(id => deleteFaq(id)));
            },
            `FAQs ${ids.join(", ")} deleted successfully`,
            `Error deleting FAQs ${ids.join(", ")}`
        );
        get().fetchFAQs();
    },
}));
